import init from '../../helpers/init';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  const d = $('.js-stat-date');
  d.on('change', (e: JQuery.ChangeEvent) => {
    e.preventDefault();
    d.parent().submit();
  });

  $(document).on('pjax:complete', function (xhr, textStatus, options) {
    const filter = $('.js-type-select');
    filter.select2({theme: 'classic'}).val();
  });
});
